module.exports = __webpack_public_path__ + "assets/images/profiles/2020-main-2-desktop.jpg?v=3d8a27dc";